import { IntlShape } from "react-intl";

import { Period } from "./IAnalyticsCharts";

export interface Point {
  x: number;
  y: number;
  color: string;
  series: {
    name: string;
  };
}

export const customToolTip = (point: Point, intl: IntlShape, period: Period): string => {
  return `
    <span>
      ${intl.formatMessage({ defaultMessage: "Last", description: "last" })}
      <b>
        ${period === Period.Daily ? "1" : period === Period.Monthly ? "28" : "7"}
      </b>
      ${period === Period.Daily ? intl.formatMessage({ defaultMessage: "day from", description: "day from text" }) : intl.formatMessage({ defaultMessage: "days from", description: "days from text" })}
      <b> 
        ${intl.formatDate(new Date(point.x),
    {
      day: "2-digit",
      month: "long",
      year: 'numeric',
    })}
      </b>
    </span> 
    <br/><br/> 
    <div>
      <span style="color:${point.color}">&#9679</span>
      <span>${point.series.name}</span>
      <span>:&nbsp</span>
      <span>${String(point.y)}</span>
    </div>
  `;
};
